module.exports = __webpack_public_path__ + "media/gallery/berlin-2-min-0250f0e7.webp";